<script>
import LegoTooltip from "@/components/Lego/LegoTooltip.vue";
import LegoControlCardDate from "@/components/Lego/LegoControlCardDate.vue";
import LegoControlCardDone from "@/components/Lego/LegoControlCardDone.vue";
import LegoControlCardEffort from "@/components/Lego/LegoControlCardEffort.vue";
import LegoControlCardAuditoria from "@/components/Lego/LegoControlCardAuditoria.vue";
import VSAvatarGroup from "@/components/Tooltip2Vue/VSAvatarGroup.vue";
import LegoCircularProgress from "@/components/Lego/LegoCircularProgress.vue";
export default {
  components: {
    LegoTooltip,
    LegoControlCardDate,
    LegoControlCardDone,
    LegoControlCardEffort,
    LegoControlCardAuditoria,
    VSAvatarGroup,
    LegoCircularProgress,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
    disabledControls: {
      type: Boolean,
      default: false,
    },
    tooltipPosition: {
      type: String,
      default: "bottom",
    },
  },
  computed: {
    roleLevel() {
      return this.$store.state.lego.currencyRole.level;
    },
  },
  methods: {
    extractDescription(text) {
      return text.replace(/<[^>]*>/g, "").trim();
    },
    openCard() {
      this.$router.push({
        name: "LegoTarjeta",
        params: { cardId: this.card.id },
      });
    },
    deleteCard() {
      this.$store.dispatch("lego/deleteCardAndSubCard", this.card);
    },
  },
};
</script>

<template>
  <div class="card-resumen" @click="openCard">
    <header class="header">
      <div>
        <div class="card-resumen--title">
          <span>
            {{ card.title }}
          </span>
        </div>
        <span v-show="card.description" class="description">
          <i class="fas fa-arrow-turn-up mr-1" style="rotate: 90deg"></i>
          {{ card.description ? extractDescription(card.description) : "" }}
        </span>
      </div>
      <div @click.stop class="controls">
        <LegoTooltip v-if="roleLevel === 1" :position="tooltipPosition">
          <!-- <span>Relaciones</span> -->
          <span class="text-lego-danger" @click="deleteCard"
            >Eliminar tarjeta</span
          >
        </LegoTooltip>
        <!-- Indicador de arrastre - solo para tarjetas principales, no subcards -->
        <!-- <div
          class="drag-indicator"
          v-if="!disabledControls && !card.LegoCardId && roleLevel === 1"
        >
          <i class="fas fa-grip-vertical"></i>
        </div> -->
      </div>
    </header>
    <div @click.stop class="tags-container">
      <LegoControlCardDone :disabled="disabledControls" :card="card" />
      <LegoControlCardDate
        :disabled="disabledControls"
        :card="card"
        position="right-start"
        v-if="card.startDate || card.dueDate"
      />
      <LegoControlCardEffort
        :disabled="disabledControls"
        :card="card"
        v-if="card.effort"
      />
      <LegoControlCardAuditoria
        :disabled="disabledControls"
        :card="card"
        v-if="card.legoAuditoriaId"
        position="right-start"
      />
      <!-- progreso  -->
      <LegoCircularProgress
        v-b-tooltip.hover
        title="Progreso de checklist"
        :size="32"
        :stroke-width="10"
        :value="card.progreso"
      />
    </div>

    <div>
      <hr />
      <div
        class="d-flex justify-content-between align-items-center"
        style="gap: 0.3rem"
      >
        <!-- responsables avatars -->
        <VSAvatarGroup
          position="bottom"
          :listAvatars="
            (card.assignments || []).map(
              (assignment) => assignment.collaborator
            )
          "
        />
        <div
          v-b-tooltip
          :title="$moment(card.createdAt).format('DD MMM, YYYY hh:mm a')"
          class="text-white-50"
        >
          <i class="fas fa-calendar-days"></i>
          {{ card.createdAt | moment("from", "now") }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card-resumen {
  background-color: var(--lego-bg);
  border: 1px solid #e1e5e9;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0.0625rem 0;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1),
    box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

  .dark & {
    /* background-color: var(--lego-bg); */
    border-color: var(--lego-hoscuro);
  }
}

.card-resumen:last-child {
  border-radius: 8px 8px 12px 12px;
}

.card-resumen:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  .dark & {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem;
}

.controls {
  opacity: 0;
  transition: 0.3s;
}

.card-resumen:hover .controls {
  opacity: 1;
}

.card-resumen--title {
  font-size: 1rem;
  font-weight: normal;
}

.tags-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.description {
  color: rgb(143, 143, 143);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

/* Indicador de arrastre */
.drag-indicator {
  opacity: 0.3;
  transition: opacity 0.2s ease;
  color: var(--text-progress);
  margin-left: 0.5rem;
  cursor: grab;
}

.card-resumen:hover .drag-indicator {
  opacity: 0.7;
}

.dark .drag-indicator {
  color: var(--text-progress);
}
</style>
